import { inject } from 'mobx-react'
import React from 'react'
import type { AuthStore } from './types'

type RestrictedViewProps = {
  requiredPermission: string
  authStore?: AuthStore
  children: any
}

@inject('authStore')
class RestrictedView extends React.PureComponent<RestrictedViewProps> {
  render() {
    const { requiredPermission, authStore, children } = this.props
    const hasPermission = authStore?.userHasPermission(requiredPermission)

    if (typeof children === 'function') {
      return children(hasPermission)
    }

    if (!hasPermission) {
      return null
    }

    return children
  }
}

export default RestrictedView
